import React from 'react';
import { motion } from 'framer-motion';
export function PricingCards() {
  return <section id="pricing" className="py-16 px-4 bg-brand-deepInk border-t border-white/5 pt-[6px] pb-[6px] relative overflow-hidden" data-id="element-227">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-228">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-12" data-id="element-229">
          ELEGÍ TU COMBO
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto relative" data-id="element-230">
          {/* Radial glows behind cards */}
          <div className="absolute top-1/2 left-1/4 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-brand-purple/20 blur-[100px] rounded-full pointer-events-none" data-id="element-231"></div>
          <div className="absolute top-1/2 right-1/4 translate-x-1/4 -translate-y-1/2 w-[300px] h-[300px] bg-brand-gold/20 blur-[100px] rounded-full pointer-events-none" data-id="element-232"></div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border-2 border-brand-green rounded-3xl p-8 shadow-[0_8px_30px_rgba(74,27,109,0.2)] flex flex-col bg-white/5 backdrop-blur-sm relative items-center z-10" data-id="element-233">
            <div className="mb-6" data-id="element-234">
              <h3 className="text-2xl font-extrabold text-white mb-2 flex items-center justify-center gap-2" data-id="element-235">
                <span data-id="element-236">📦</span> MEGAPACK EMPRENDE CON DIOS
              </h3>
              <p className="font-bold text-brand-neon mb-4" data-id="element-237">
                6 Tomos Maestros + 6 Bonos Estratégicos
              </p>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-238">
                Ideal para emprendedoras que quieren arrancar con el producto y
                la venta. Aprendé a fabricar, presentar y vender tus frasquitos
                cristianos desde hoy.
              </p>
            </div>

            <div className="mb-8 mt-auto" data-id="element-239">
              <p className="text-gray-500 line-through text-lg font-bold mb-1" data-id="element-240">
                $51.000
              </p>
              <div className="flex items-baseline gap-2 justify-center" data-id="element-241">
                <span className="text-5xl font-extrabold text-white" data-id="element-242">
                  $19.990
                </span>
                <span className="text-xl font-bold text-gray-400" data-id="element-243">ARS</span>
              </div>
            </div>

            <motion.a href="https://www.impulsodigitalstore.com/cart/42985551102029:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-brand-green text-white font-bold text-lg py-4 px-6 rounded-xl shadow-[0_8px_20px_rgba(74,27,109,0.4)] hover:shadow-[0_10px_30px_rgba(74,27,109,0.6)] transition-all text-center inline-block" data-id="element-244">
              🌸 QUIERO MI MEGAPACK AHORA
            </motion.a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="border-4 border-brand-pink rounded-3xl p-8 shadow-[0_10px_40px_rgba(201,168,76,0.3)] flex flex-col bg-white/5 backdrop-blur-sm relative md:-translate-y-4 items-center z-10" data-id="element-245">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-pink text-white px-6 py-1.5 rounded-full font-bold text-sm shadow-md whitespace-nowrap" data-id="element-246">
              MÁS POPULAR
            </div>

            <div className="mb-6 mt-2" data-id="element-247">
              <h3 className="text-2xl font-extrabold text-white mb-2 flex items-center justify-center gap-2" data-id="element-248">
                <span data-id="element-249">👑</span> MEGAPACK + SISTEMA $100.000 ⭐
              </h3>
              <p className="font-bold text-brand-pink mb-4" data-id="element-250">
                6 Tomos + 6 Bonos + Planificador Próspero 365
              </p>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-251">
                Ideal para quienes buscan facturar sus primeros 6 dígitos rápido
                organizando finanzas, producción y ventas bajo un método
                probado.
              </p>
            </div>

            <div className="mb-8 mt-auto" data-id="element-252">
              <p className="text-gray-500 line-through text-lg font-bold mb-1" data-id="element-253">
                $69.000
              </p>
              <div className="flex items-baseline gap-2 justify-center" data-id="element-254">
                <span className="text-5xl font-extrabold text-white" data-id="element-255">
                  $27.990
                </span>
                <span className="text-xl font-bold text-gray-400" data-id="element-256">ARS</span>
              </div>
            </div>

            <motion.a href="https://www.impulsodigitalstore.com/cart/42985557327949:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-brand-pink text-white font-bold text-lg py-4 px-6 rounded-xl shadow-[0_8px_20px_rgba(201,168,76,0.4)] hover:shadow-[0_10px_30px_rgba(201,168,76,0.6)] transition-all text-center inline-block" data-id="element-257">
              👑 QUIERO EL SISTEMA $100.000
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>;
}